export const TEST_ID_PRICE_CHEKER_WARNING = 'price-checker-warning';
